import IntroScreenContent from './IntroScreenContent'

export default IntroScreenContent
